exports.version = "1.9.3"


//////////////////
// WEBPACK FOOTER
// /~/apollo-client/version.js
// module id = 3Y6g
// module chunks = 0